import {
  Component, ElementRef,
  Injector, NgZone, OnInit,
  Optional, Renderer2, SecurityContext, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { isString } from 'lodash-es';

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  SanitizePipe
} from "@wm/components-base";
import {getCanvasElement, setAttr, setCSS, setHtml} from "@wm/core";

const DEFAULT_CLS = 'app-richtexteditor clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-richtexteditor',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'div[wmRichTextEditor]',
  template: `
      <div richTextEditor></div>
      <div *ngIf="showpreview" [innerHTML]="proxyModel" class="ta-preview"></div>
      <input class="model-holder" [disabled]="disabled" hidden>`,
  providers: [
    provideAsWidgetRef(RichTextEditorComponent),SanitizePipe
  ],
  exportAs: 'wmRichTextEditor',
  standalone: true,
  imports: [CommonModule],
  styles: []
})
export class RichTextEditorComponent extends StylableComponent implements OnInit {
  static initializeProps = register('wm-richtexteditor');
  $richTextEditor: any;
  $hiddenInputEle: any;
  proxyModel: any;
  _operationStack = [];
  isEditorLoaded = false;
  public showpreview: boolean;
  public disabled: boolean;
  @ViewChild('ratingInput', /* TODO: add static flag */ {read: ElementRef}) ratingEl: ElementRef;


  EDITOR_DEFAULT_OPTIONS = {
    toolbar: [
      // [groupName, [list of button]]
      ['misc', ['undo', 'redo']],
      ['style', ['style']],
      ['fontname', ['fontname']],
      ['fontsize', ['fontsize']],
      ['height', ['height']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['strikethrough', 'superscript', 'subscript']],
      ['color', ['color']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['misc', ['codeview', 'fullscreen', 'help']]
    ],
    callbacks: {
      onInit: () => {
        this.isEditorLoaded = true;
        if (this._operationStack.length) {
          this._operationStack.forEach((operationParam: any) => {
            const key = Array.from(operationParam.keys())[0],
              val = operationParam.get(key);
            this.performEditorOperation(key, val);
          });
          this._operationStack = [];
        }
      },
      onChange: (contents: any, editable: any) => {
        this.proxyModel = this.sanitizePipe.transform(contents, SecurityContext.HTML);
      }
    },
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Merriweather'],
    placeholder: 'write here...',
    minHeight: 100,
    disableResizeEditor: true,
    disableDragAndDrop: true,
  };

  constructor(inj: Injector, private sanitizePipe: SanitizePipe, private ngZone: NgZone,public renderer: Renderer2,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);


  }

  get htmlcontent() {
    return this.performEditorOperation('code');
  }

  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('div.note-editable ') || this.nativeElement;
  }

  performEditorOperation(key: any, value?: any) {
    if (this.isEditorLoaded) {
      if (key === 'height') {
        setCSS(this.renderer.selectRootElement('div.note-editable'), key, value, true);
      } else if (key === 'placeholder') {
        setAttr(this.nativeElement, key, value);
        let canvasEl = getCanvasElement();
        let placeholderEl = $(canvasEl).find('div.note-placeholder');
        setHtml(this.renderer.selectRootElement(placeholderEl[0]), value, true);
      }else {
        // if editor content is empty then summernote('code') is returning empty p tags like <p></br></p>. So checking for empty and returning undefined.
        if (arguments.length === 1 && key === 'code' && this.$richTextEditor.summernote('isEmpty')) {
          const content = this.$richTextEditor.summernote('code');
          return content === '' ? content : undefined;
        }
        return this.$richTextEditor.summernote(key, value);
      }
    }
  }

  override ngOnInit() {
    this.$richTextEditor = $(this.nativeElement.querySelectorAll('[richTextEditor]'));
    this.$hiddenInputEle = $(this.nativeElement.querySelectorAll('input.model-holder'));

    super.ngOnInit();
    this.initEditor();
  }

  initEditor() {
    this.ngZone.runOutsideAngular(() => {
      this.$richTextEditor.summernote(this.EDITOR_DEFAULT_OPTIONS);
    });

  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'placeholder') {
      this.performEditorOperation('placeholder', nv);
    } else if (key === 'disabled' || key === 'readonly') {
      this.performEditorOperation(nv ? 'disable' : 'enable');
    } else if (key === 'showpreview') {
      if (nv === true) {
        this.showpreview = true;
      } else {
        this.showpreview = false;
      }
    } else if (key === 'datavalue') {
      if (isString(nv) && nv.startsWith('bind:')) {
        return;
      }
      if (nv !== undefined && nv !== null) {
        this.$hiddenInputEle.val(nv);
        this.performEditorOperation('reset');
        this.performEditorOperation('code', nv);
      }
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }


}
